import Image from "next/image";

const InfrastructureSection = ({ data }) => {
    const largeImages = data.images.filter(
        (img) => img.size === "large"
    );

    const smallImages = data.images.filter(
        (img) => img.size === "small"
    );

    return (
        <section className="max-w-(--max-page-width) mx-auto px-(--container-padding) my-10 md:my-16 lg:my-24">

            <div className="text-center max-w-2xl mx-auto mb-5 md:mb-10">

                <span className="bg-[#FFA2011A]/90 text-[#FFA201] text-[13px] font-normal px-3 py-2 capitalize">
                    {data.tag}
                </span>

                <h2 className="text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] font-bold mt-4">
                    {data.title}
                </h2>

                <p className="text-[#000000] mt-3 text-lg">
                    {data.description}
                </p>

            </div>

            <div className="w-full mx-auto space-y-6">

                <div className="grid md:grid-cols-2 gap-6">

                    {largeImages.map((item) => (
                        <div
                            key={item.id}
                            className="relative w-full h-85 overflow-hidden"
                        >
                            <Image
                                src={item.src}
                                alt=""
                                fill
                                className="object-cover"
                            />
                        </div>
                    ))}

                </div>

                <div className="grid md:grid-cols-3 gap-6">

                    {smallImages.map((item) => (
                        <div
                            key={item.id}
                            className="relative w-full h-72 overflow-hidden"
                        >
                            <Image
                                src={item.src}
                                alt={item.alt}
                                fill
                                className="object-cover"
                            />
                        </div>
                    ))}

                </div>

            </div>

        </section>
    );
}

export default InfrastructureSection;